// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"240":"support","374":"gameHistoryItem","472":"settings","488":"flashCards","555":"gameHistory","703":"addOrEditWord","982":"anki"}[chunkId] + "." + {"240":"c19da93e","374":"7e0b96cc","472":"3eef1b46","488":"21592e5e","555":"c410ad57","703":"6342f291","982":"7b3af577"}[chunkId] + ".css";
};